import { DefaultOptionType } from 'antd/es/select';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useSelectOnDrawer = (
  options,
  filter,
  selection,
  onChange,
  onSearch,
  mode,
  setOpenDrawer,
  dynamicHeight,
) => {
  const [filteredOptions, setFilteredOptions] = useState<DefaultOptionType[]>([]);
  const [optionsToShow, setOptionsToShow] = useState<DefaultOptionType[]>([]);
  const [lastItemId, setLastItemId] = useState<any>(null);
  const [searchValue, setSearchValue] = useState('');
  const appendData = useCallback(() => {
    const actualLenght = optionsToShow.length;

    if (filteredOptions) {
      setOptionsToShow(prevValue => [
        ...prevValue,
        ...filteredOptions.slice(actualLenght, actualLenght + 20),
      ]);
    }
  }, [filteredOptions, optionsToShow.length]);
  const heightStyle = useMemo(() => {
    if (!dynamicHeight) {
      return {
        height: 'fit-content',
      };
    }

    const itemHeight = document.getElementById(`drawer-select-item-${lastItemId}`)?.offsetHeight;
    const heightPerItem = !itemHeight || itemHeight <= 49 ? 49 : itemHeight;

    if (options) {
      if (options?.length < 14) {
        return {
          height: (options?.length + 1) * heightPerItem,
        };
      } else {
        return { minHeight: 15 * heightPerItem, height: 'fit-content' };
      }
    }
  }, [lastItemId, options, dynamicHeight]);

  useEffect(() => {
    if (optionsToShow.length != 0) {
      setLastItemId(optionsToShow[optionsToShow.length - 1].value || 'undefined');
    }
  }, [optionsToShow]);

  useEffect(() => {
    appendData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredOptions]);

  useEffect(() => {
    const element = document.getElementById(`drawer-select-item-${lastItemId}`);
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          appendData();
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 1.0,
      },
    );

    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [appendData, lastItemId]);

  useEffect(() => {
    if (options) {
      if (onSearch) {
        setFilteredOptions(options);
      } else {
        setFilteredOptions(options.filter(opt => filter(searchValue, opt)));
      }
    }
  }, [filter, onSearch, options, searchValue]);

  useEffect(() => {
    return () => {
      onSearch?.('');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeSearch = e => {
    setOptionsToShow([]);
    setSearchValue(e.target.value);
    onSearch?.(e.target.value);
  };

  const onClick = (value, opt, selected) => {
    const valueToSet =
      mode == 'multiple'
        ? selected
          ? selection
            ? Array.isArray(selection) && selection.filter(v => value != v)
            : [value]
          : selection
            ? [...selection, value]
            : [value]
        : selected
          ? undefined
          : value;

    if (onChange) {
      onChange(valueToSet, opt);
    }

    if (mode != 'multiple') {
      setOpenDrawer(false);
    }
  };

  return { heightStyle, searchValue, optionsToShow, onClick, onChangeSearch };
};
